export default __webpack_public_path__ + "static/media/registration-demo.7e3d53da.svg";